import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { db } from "../../services/firebase/Config";
import { useSelector, useDispatch } from "react-redux";

import AddIcon from "@material-ui/icons/Add";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { IconButton, Tooltip, Zoom, Checkbox, FormControlLabel, Popover, Button, Box } from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { PrestacionSeleccionModal } from "../Prestaciones/Modales/PrestacionSeleccionModal/index";
import { NuevaPrestacionModal } from "../Prestaciones/Modales/NuevaPrestacionModal/index";
import { TerminarPrestacionModal } from "../Prestaciones/Modales/TerminarPrestacionModal/index";
import { TerminarPrestacionOdontoModal } from "../Prestaciones/Modales/TerminarPrestacionOdontoModal/index";
import { ConfirmacionSiNoModal } from "../../components/ConfirmacionSiNoModal/index";
import {
    updateActiveAtencionItems,
    startAtencionActiva,
    closeAtencionActiva,
    checkAtencionActiva,
    linkTreatmentToAtencion,
    unlinkTreatmentFromAtencion,
    linkMultipleTreatmentsToAtencion,
} from "../../redux/atenciones/atencionesActions";
import {
    newPrestation,
    actualizarNotas,
    setPrestation,
    setCaras,
    terminarPrestacionTrx,
    terminarPrestacionOdontoTrx,
    restaurarPrestacionTrx,
    updatePrestation
} from "../../redux/prestation/prestationActions";
import { addPrestationDb } from "../../redux/prestations/prestationsActions";
import { newToothSelection } from "../../redux/denticion/denticionActions";
import { useToasts } from "react-toast-notifications";
import {
    fetchSesionesByAtencion,
    updateSesionNota,
    updateSesionExecution
} from "../../services/firebase/sesiones";
import { OdontoExecution } from "./components/OdontoExecution";
import {
    MainContainer,
    ContainerBody,
    WorkspaceHeader,
    WorkspaceTitle,
    SectionAtencion,
    TarjetaAtencion,
    InfoTratamiento,
    NombreTratamiento,
    DientesEtiqueta,
    NotaClinicaContainer,
    NotaClinicaTextarea,
    AccionesTarjeta,
    ButtonAdd,
    ButtonCompletar,
    ButtonFinalizar,
    ButtonIniciar,
    EmptyState,
    SesionIndicator,
    TimeContainer,
    TimeField
} from "./styles";
import { fetchDiagnosticos, setDiagnosticoPlanificadoLocal } from "../../redux/diagnosticos/diagnosticosActions";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import moment from "moment";

// Componente para una prestación individual en la sesión
const ItemAtencion = ({ item, sesionBridge, onRemove, onComplete, onRevert, onAskComplete, onNoteChange, onUpdate, pacienteId, empresaId, currentNote }) => {
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const [notaLocal, setNotaLocal] = React.useState("");
    const [priceLocal, setPriceLocal] = React.useState(item.precio);

    // Popover state
    const [anchorEl, setAnchorEl] = React.useState(null);

    const isTerminado = item.estado === "TERMINADO";
    // Only editable if PENDIENTE
    const canEditPrice = item.estado === "PENDIENTE";

    React.useEffect(() => {
        let val = "";
        if (isTerminado && item.notasClinicas && item.notasClinicas.length > 0) {
            val = item.notasClinicas[0].nota;
        } else if (currentNote !== undefined) {
            val = currentNote;
        } else if (sesionBridge) {
            val = sesionBridge.nota || "";
        }
        setNotaLocal(val);

        if (onNoteChange && !isTerminado && currentNote === undefined) onNoteChange(item.id, val);
    }, [isTerminado, item.notasClinicas, sesionBridge, item.id, currentNote]);

    const handleCheck = (e) => {
        if (e.target.checked) {
            onAskComplete(item, notaLocal);
        } else {
            onRevert(item);
        }
    };

    const handleBlurNota = () => {
        if (!isTerminado && sesionBridge) {
            updateSesionNota(pacienteId, sesionBridge.id, notaLocal, empresaId);
        }
    };

    const handleChangeNota = (e) => {
        const val = e.target.value;
        setNotaLocal(val);
        if (onNoteChange) onNoteChange(item.id, val);
    };

    // Open Popover
    const handlePriceClick = (event) => {
        if (canEditPrice) {
            setPriceLocal(item.precio); // Reset local price to current item price when opening
            setAnchorEl(event.currentTarget);
        }
    };

    // Close Popover
    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const openPopover = Boolean(anchorEl);
    const idPopover = openPopover ? 'simple-popover' : undefined;

    const handleSavePrice = () => {
        const newPrice = Number(priceLocal);
        const paid = Number(item.pagado || 0);

        if (isNaN(newPrice)) {
            setPriceLocal(item.precio);
            return;
        }

        if (newPrice < paid) {
            addToast(`El precio no puede ser menor a lo pagado (${paid})`, { appearance: 'error' });
            return;
        }

        if (newPrice !== item.precio) {
            const updatedItem = { ...item, precio: newPrice };
            dispatch(updatePrestation(updatedItem));
            if (onUpdate) onUpdate(updatedItem);
            addToast("Precio actualizado", { appearance: 'success' });
        }
        handleClosePopover();
    };

    return (
        <TarjetaAtencion terminado={isTerminado}>
            <InfoTratamiento>
                <SesionIndicator final={isTerminado}>
                    {isTerminado ? "Sesión Final" : "Sesión Parcial"}
                </SesionIndicator>
                <NombreTratamiento>{item.tratamiento}</NombreTratamiento>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <DientesEtiqueta>
                        {item.dientes && item.dientes.length > 0
                            ? `Dientes: ${item.dientes.join(", ")}`
                            : "Tratamiento General"}
                    </DientesEtiqueta>
                    <span style={{
                        fontSize: '0.75rem',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        backgroundColor: item.estado === 'TERMINADO' ? '#e8f5e9' : item.estado === 'ACTIVO' ? '#e3f2fd' : '#fff3e0',
                        color: item.estado === 'TERMINADO' ? '#2e7d32' : item.estado === 'ACTIVO' ? '#1565c0' : '#ef6c00',
                        fontWeight: 'bold',
                        border: '1px solid',
                        borderColor: item.estado === 'TERMINADO' ? '#a5d6a7' : item.estado === 'ACTIVO' ? '#90caf9' : '#ffcc80'
                    }}>
                        {item.estado === 'PENDIENTE' ? 'PLANIFICADO' : item.estado === 'ACTIVO' ? 'EN PROGRESO' : item.estado === 'TERMINADO' ? 'FINALIZADO' : item.estado}
                    </span>
                </div>

                <div
                    style={{ marginTop: '5px', display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                    <span style={{ fontSize: '0.85rem', color: '#555' }}>Precio: </span>
                    <span
                        aria-describedby={idPopover}
                        onClick={handlePriceClick}
                        style={{
                            fontWeight: 'bold',
                            color: canEditPrice ? '#0c8de3' : '#555',
                            cursor: canEditPrice ? 'pointer' : 'default',
                            borderBottom: canEditPrice ? '1px dashed #0c8de3' : 'none'
                        }}
                    >
                        {item.precio}
                    </span>

                    {/* Popover for editing price */}
                    <Popover
                        id={idPopover}
                        open={openPopover}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <Box p={2} display="flex" flexDirection="column" gap={1}>
                            <span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>Editar Precio</span>
                            <div style={{ display: 'flex', gap: '5px' }}>
                                <input
                                    type="number"
                                    value={priceLocal}
                                    onChange={(e) => setPriceLocal(e.target.value)}
                                    style={{
                                        width: '80px',
                                        padding: '4px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc'
                                    }}
                                    autoFocus
                                />
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSavePrice}
                                    style={{ minWidth: '40px', padding: '0 10px' }}
                                >
                                    OK
                                </Button>
                            </div>
                        </Box>
                    </Popover>
                </div>

            </InfoTratamiento>



            <NotaClinicaContainer>
                <NotaClinicaTextarea
                    placeholder="Escriba aquí la nota clínica de la sesión actual (procedimientos realizados, observaciones, etc.)..."
                    disabled={isTerminado}
                    value={notaLocal}
                    onChange={handleChangeNota}
                    onBlur={handleBlurNota}
                />
            </NotaClinicaContainer>

            <AccionesTarjeta>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', alignItems: 'center' }}>
                    <Tooltip title={isTerminado ? "Este tratamiento ya ha sido marcado como finalizado." : "Marcar como sesión final. Al completar, se cierra el tratamiento y se actualiza el odontograma."} TransitionComponent={Zoom}>
                        <ButtonCompletar
                            onClick={() => handleCheck({ target: { checked: !isTerminado } })}
                            style={{
                                background: isTerminado ? '#4caf50' : '#0c8de3',
                                color: 'white',
                                width: '100%',
                                marginTop: '5px'
                            }}
                        >
                            {isTerminado ? <CheckCircleOutlineIcon style={{ marginRight: 5 }} /> : <PlayArrowIcon style={{ marginRight: 5 }} />}
                            {isTerminado ? "No terminar" : "Terminar Prestación"}
                        </ButtonCompletar>
                    </Tooltip>

                    <Tooltip title="Quitar de esta sesión" TransitionComponent={Zoom}>
                        <IconButton
                            onClick={() => onRemove(item.id)}
                            color="secondary"
                            size="small"
                            disabled={isTerminado}
                        >
                            <DeleteOutlineIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <div style={{ fontSize: '0.7rem', color: '#888', marginTop: 'auto', textAlign: 'center' }}>
                    COD: {item.id.substring(0, 8).toUpperCase()}
                </div>
            </AccionesTarjeta>
        </TarjetaAtencion>
    );
};



export const Atencion = () => {
    const dispatch = useDispatch();

    const atenciones = useSelector((state) => state.atenciones);
    const sesionRedux = useSelector((state) => state.sesion);
    const prestaciones = useSelector((state) => state.prestaciones);
    const sesionesHoy = atenciones.sesiones;
    const atencionActiva = atenciones.atencionActiva;
    const paciente = useSelector((state) => state.paciente);
    const diagnosticos = useSelector((state) => state.diagnosticos);
    const odontograma = useSelector((state) => state.odontograma);
    const cuenta = useSelector((state) => state.cuenta);
    const { addToast } = useToasts();
    const [loading, setLoading] = React.useState(false);

    const [startTime, setStartTime] = React.useState("");
    const [duration, setDuration] = React.useState("00:00:00");
    const [modalSeleccionIsOpen, setModalSeleccionIsOpen] = React.useState(false);
    const [modalNuevoTratamientoIsOpen, setModalNuevoTratamientoIsOpen] = React.useState(false);
    const [modalConfirmacionCierreIsOpen, setModalConfirmacionCierreIsOpen] = React.useState(false);
    const [modalDidacticoCompletarIsOpen, setModalDidacticoCompletarIsOpen] = React.useState(false);
    const [itemPendingComplete, setItemPendingComplete] = React.useState(null);
    const [notaPendingComplete, setNotaPendingComplete] = React.useState("");
    const [modalTerminarOdontoIsOpen, setModalTerminarOdontoIsOpen] = React.useState(false);
    const [modalTerminarIsOpen, setModalTerminarIsOpen] = React.useState(false);
    const [pendingCompleteData, setPendingCompleteData] = React.useState(null);
    const [localPrestaciones, setLocalPrestaciones] = React.useState([]);

    const handleLocalUpdate = (updatedItem) => {
        setLocalPrestaciones(prev => prev.map(p => p.id === updatedItem.id ? { ...p, ...updatedItem } : p));
    };

    const fetchLocalPrestaciones = async () => {
        if (!paciente?.id || !paciente?.empresaId) return;
        try {
            const snapshot = await db.collection("empresas").doc(paciente.empresaId).collection("pacientes").doc(paciente.id).collection("prestaciones")
                .where("estado", "in", ["ACTIVO", "PENDIENTE", "TERMINADO"])
                .get();

            const loaded = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                fechaFin: doc.data().fechaFin?.toDate ? doc.data().fechaFin.toDate() : doc.data().fechaFin
            }));
            setLocalPrestaciones(loaded);
        } catch (error) {
            console.error("Error fetching local prestations:", error);
        }
    };

    React.useEffect(() => {
        fetchLocalPrestaciones();
    }, [paciente?.id, modalTerminarIsOpen, modalTerminarOdontoIsOpen, modalSeleccionIsOpen, modalNuevoTratamientoIsOpen]);

    React.useEffect(() => {
        let interval;

        if (atencionActiva?.fechaInicio) {
            let date;
            const fecha = atencionActiva.fechaInicio;

            // Normalize Date
            if (fecha?.toDate) {
                date = fecha.toDate();
            } else if (fecha instanceof Date) {
                date = fecha;
            } else if (typeof fecha === 'string') {
                date = new Date(fecha);
            } else if (typeof fecha === 'number') {
                date = new Date(fecha);
            } else if (fecha?.seconds) {
                date = new Date(fecha.seconds * 1000);
            } else {
                date = new Date();
            }

            const startMoment = moment(date);

            if (!startMoment.isValid()) {
                setStartTime("Error");
                setDuration("00:00:00");
                return;
            }

            setStartTime(startMoment.format("HH:mm:ss"));

            // Initial calculation
            const updateDuration = () => {
                const now = moment();
                // "que el tiempo transcurrido lo calcule desde la hora actual menos la hora que inicio"
                const diff = now.diff(startMoment);
                // Ensure non-negative duration
                const durationMs = diff > 0 ? diff : 0;
                setDuration(moment.utc(durationMs).format("HH:mm:ss"));
            };

            updateDuration(); // Immediate update
            interval = setInterval(updateDuration, 1000);
        } else {
            setStartTime("--:--:--");
            setDuration("00:00:00");
        }

        return () => {
            if (interval) clearInterval(interval);
        };
        // Depend only on the specific fechaInicio value (primitive or reference stability) to avoid resetting interval on other atencionActiva changes
    }, [atencionActiva?.fechaInicio]);

    // Filtrar prestaciones reales presentes en la sesión (ahora en atencionActiva.items)
    const sessionItems = atencionActiva?.items || [];
    const itemsAMostrar = localPrestaciones.filter(p =>
        sessionItems.includes(p.id)
    );

    const handleLinkExistingTreatment = () => {
        setModalSeleccionIsOpen(true);
    };

    const onSelectExistingTreatments = (ids) => {
        ids.forEach(id => {
            dispatch(linkTreatmentToAtencion(paciente.id, atencionActiva.id, id, sesionRedux.usuario.email));
        });
        setModalSeleccionIsOpen(false);
        addToast("Tratamientos vinculados", { appearance: "success" });
    };

    React.useEffect(() => {
        console.log("DEBUG: Modal States Updated -> Terminar:", modalTerminarIsOpen, "Odonto:", modalTerminarOdontoIsOpen);
    }, [modalTerminarIsOpen, modalTerminarOdontoIsOpen]);

    const handleOpenNuevoTratamiento = () => {
        dispatch(newToothSelection());
        dispatch(newPrestation());
        setModalNuevoTratamientoIsOpen(true);
    };

    const lastModalCloseTime = React.useRef(0);

    const handleAskCompleteTreatment = (item, nota) => {
        const timeSinceClose = Date.now() - lastModalCloseTime.current;
        console.log("DEBUG: handleAskCompleteTreatment called. Time since last close:", timeSinceClose);

        if (timeSinceClose < 1000) {
            console.warn("DEBUG: Preventing modal reopen (Debounce)");
            return;
        }

        console.log("DEBUG: Opening modal for item", item.id);
        /*
        if (!nota || nota.trim() === "") {
            addToast("Debe ingresar una nota clínica antes de completar el tratamiento", { appearance: "warning" });
            return;
        }

        setItemPendingComplete(item);
        setNotaPendingComplete(nota);
        setModalDidacticoCompletarIsOpen(true);
        */

        const { grupo, afectaOdonto } = item.config;

        // Attach the current session note to the item state so it's available in the modal
        const itemWithNote = { ...item };
        if (nota && nota.trim() !== "") {
            const notaObj = {
                fecha: Date.now(),
                nota: nota,
                especialista: sesionRedux.usuario.email,
            };
            itemWithNote.notasClinicas = [notaObj, ...(item.notasClinicas || [])];
        }

        dispatch(setPrestation(itemWithNote));
        if (grupo == "CORONA" || grupo == "EXODONCIA") {
            dispatch(setCaras([1, 2, 3, 4, 5]));
        }

        if (afectaOdonto) {
            setModalTerminarOdontoIsOpen(true);
        } else {
            setModalTerminarIsOpen(true);
        }
    };

    const handleConfirmAskComplete = () => {
        setModalDidacticoCompletarIsOpen(false);
        handleCompleteTreatment(itemPendingComplete, notaPendingComplete);
    };

    const handleCompleteTreatment = async (item, nota) => {
        try {
            setLoading(true);
            if (!nota || nota.trim() === "") {
                addToast("Debe ingresar una nota clínica antes de completar el tratamiento", { appearance: "warning" });
                setLoading(false);
                return;
            }

            const sesionBridge = atenciones.sesiones.find(s => s.prestacionId === item.id);
            const { grupo, afectaOdonto } = item.config;

            if (afectaOdonto) {
                if (!sesionBridge) {
                    addToast("Error: No se encontró el registro de la sesión", { appearance: "error" });
                    setLoading(false);
                    return;
                }

                // Validaciones previas al completado basado en los datos de la sesión bridge
                if (grupo === "CARAS" && (!sesionBridge.caras || sesionBridge.caras.length === 0)) {
                    addToast("Debe seleccionar al menos una cara del diente", { appearance: "warning" });
                    setLoading(false);
                    return;
                }
                if (item.config.coronaTipo === "PUENTE" && (!sesionBridge.pilares || sesionBridge.pilares.length === 0)) {
                    addToast("Debe seleccionar pilares para el puente", { appearance: "warning" });
                    setLoading(false);
                    return;
                }
            }

            const notaObj = {
                fecha: Date.now(),
                nota: nota,
                especialista: sesionRedux.usuario.email,
            };

            const itemToComplete = {
                ...item,
                fechaFin: new Date(),
                notasClinicas: [notaObj, ...(item.notasClinicas || [])],
                caras: sesionBridge?.caras || [],
                pilares: sesionBridge?.pilares || []
            };

            let myOdontograma = Object.assign({}, odontograma);
            myOdontograma.pacienteId = paciente.id;
            myOdontograma.especialistaId = sesionRedux.usuario.email;
            myOdontograma.empresaId = sesionRedux.usuario.empresaId;

            await dispatch(terminarPrestacionOdontoTrx(itemToComplete, myOdontograma, cuenta));
            addToast(`${item.tratamiento} marcado como completado`, { appearance: "success" });
        } catch (error) {
            addToast("Error al completar tratamiento: " + error.message, { appearance: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleCloseCompletionModals = () => {
        lastModalCloseTime.current = Date.now();
        setModalTerminarOdontoIsOpen(false);
        setModalTerminarIsOpen(false);
        dispatch(setPrestation(null));
        dispatch(setCaras([]));
    };

    const handleRevertTreatment = (item) => {
        dispatch(restaurarPrestacionTrx(item))
            .then(() => {
                addToast(`${item.tratamiento} restaurado a estado activo`, { appearance: "info" });
            })
            .catch((error) => {
                addToast("Error al restaurar tratamiento: " + error.message, { appearance: "error" });
            });
    };

    const handleAddToPlan = async (prestacionOrArray) => {
        const prestaciones = Array.isArray(prestacionOrArray) ? prestacionOrArray : [prestacionOrArray];

        try {
            setLoading(true);
            const promises = prestaciones.map(p => dispatch(addPrestationDb(p)));
            const ids = await Promise.all(promises);
            const validIds = ids.filter(id => id); // Filter out undefined/null if any failure handled gracefully inside action returning nothing

            if (validIds.length > 0) {
                await dispatch(linkMultipleTreatmentsToAtencion(
                    paciente.id,
                    atencionActiva.id,
                    validIds,
                    sesionRedux.usuario.email
                ));
                addToast(`${validIds.length} tratamiento(s) agregado(s) y vinculado(s)`, { appearance: "success" });
            }
        } catch (error) {
            console.error("Error adding treatments:", error);
            addToast("Error al agregar tratamientos", { appearance: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveFromSession = (id) => {
        dispatch(unlinkTreatmentFromAtencion(paciente.id, atencionActiva.id, id));
        addToast("Tratamiento quitado de la sesión", { appearance: "info" });
    };

    const handleCloseModals = () => {
        setModalSeleccionIsOpen(false);
        setModalNuevoTratamientoIsOpen(false);
    };

    const handleIniciarAtencion = async () => {
        const atencionData = {
            pacienteId: paciente.id,
            especialistaId: sesionRedux.usuario.email,
            empresaId: sesionRedux.usuario.empresaId,
            fechaInicio: new Date(),
            estado: "ABIERTA"
        };

        try {
            setLoading(true);
            const newAtencion = await dispatch(startAtencionActiva(atencionData));

            // Auto-link ACTIVE treatments
            const activeTreatments = localPrestaciones
                .filter(p => p.estado === 'ACTIVO')
                .map(p => p.id);

            if (activeTreatments.length > 0 && newAtencion?.id) {
                await dispatch(linkMultipleTreatmentsToAtencion(
                    paciente.id,
                    newAtencion.id,
                    activeTreatments,
                    sesionRedux.usuario.email
                ));
            }

            addToast("Atención iniciada correctamente", { appearance: "success" });
        } catch (error) {
            addToast("No se pudo iniciar la atención: " + error.message, { appearance: "error" });
        } finally {
            setLoading(false);
        }
    };

    const [sessionNotes, setSessionNotes] = React.useState({});

    const handleNoteChange = (itemId, note) => {
        setSessionNotes(prev => ({ ...prev, [itemId]: note }));
    };

    const handleCerrarAtencion = () => {
        // Validation that start time is before end time is implicit now as we use current time for end time logic
        // and start time is fixed from DB. Only minimal sanity check if needed, but removing user input validation.

        // Validate that all items have notes
        const missingNotes = itemsAMostrar.filter(item => {
            // If terminated, it has notes in history
            if (item.estado === "TERMINADO") return false;

            // Check new note or existing session note
            const sesionBridge = sesionesHoy.find(s => s.prestacionId === item.id);
            const note = sessionNotes[item.id] !== undefined ? sessionNotes[item.id] : (sesionBridge?.nota || "");

            return note.trim() === "";
        });

        if (missingNotes.length > 0) {
            addToast(`Faltan notas clínicas para ${missingNotes.length} tratamiento(s).`, { appearance: "warning" });
            return;
        }

        setModalConfirmacionCierreIsOpen(true);
    };

    const onConfirmCerrarAtencion = async () => {
        setModalConfirmacionCierreIsOpen(false);
        try {
            setLoading(true);
            await dispatch(closeAtencionActiva(atencionActiva.id, paciente.id, sesionRedux.usuario.email));
            addToast("Atención finalizada", { appearance: "success" });
        } catch (error) {
            addToast("Error al finalizar atención: " + error.message, { appearance: "error" });
        } finally {
            setLoading(false);
        }
    };

    const handlePlanificarDiagnostico = async (diag) => {
        try {
            // Convert Diagnostic to Level 1 (Prestación/Plan)
            const newPrestacion = {
                ...diag,
                estado: "PENDIENTE",
                id: null,
                fechaInicio: new Date(),
                tipo: diag.tipo || "Tratamiento",
                precio: diag.precio || 0,
                pagado: 0,
                estfin: "PENDIENTE",
                pacienteId: paciente.id
            };

            const newId = await dispatch(addPrestationDb(newPrestacion));
            if (newId) {
                dispatch(setDiagnosticoPlanificadoLocal(diag.id));
                addToast("Hallazgo convertido a Plan de Tratamiento", { appearance: "success" });
            }
        } catch (error) {
            addToast("Error al planificar: " + error.message, { appearance: "error" });
        }
    };

    if (loading)
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100%' }}>
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );

    return (
        <React.Fragment>

            <MainContainer>
                <ContainerBody>
                    <WorkspaceHeader>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <WorkspaceTitle>Espacio de Atención Clínica</WorkspaceTitle>
                                {atencionActiva ? (
                                    <ButtonFinalizar onClick={handleCerrarAtencion}>
                                        <PowerSettingsNewIcon /> Finalizar Atención
                                    </ButtonFinalizar>
                                ) : (
                                    <ButtonIniciar onClick={handleIniciarAtencion}>
                                        <PlayArrowIcon /> Iniciar Atención
                                    </ButtonIniciar>
                                )}
                            </div>
                            {atencionActiva && (
                                <div style={{ marginLeft: '15px', marginTop: '10px' }}>



                                    <TimeContainer>
                                        <TimeField>
                                            <label>Iniciada</label>
                                            <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>{startTime}</span>
                                        </TimeField>
                                        <div style={{ color: '#ccc', fontWeight: 'bold' }}>→</div>
                                        <TimeField>
                                            <label>Tiempo Transcurrido</label>
                                            <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#0c8de3' }}>{duration}</span>
                                        </TimeField>
                                    </TimeContainer>
                                </div>
                            )}
                        </div>
                        {atencionActiva && (
                            <div style={{ display: 'flex', gap: '10px', marginTop: 'auto' }}>
                                <ButtonAdd onClick={handleLinkExistingTreatment}>
                                    <AddIcon /> Vincular Existente
                                </ButtonAdd>
                                <ButtonAdd onClick={handleOpenNuevoTratamiento} style={{ background: '#0c8de3', color: 'white' }}>
                                    <AddIcon /> Nueva Prestacion
                                </ButtonAdd>
                            </div>
                        )}
                    </WorkspaceHeader>

                    <SectionAtencion>
                        {!atencionActiva ? (
                            <EmptyState>
                                <h2>No hay una atención activa</h2>
                                <p>Para acceder al espacio de trabajo clínico, primero debe iniciar la atención del paciente desde la barra superior.</p>
                            </EmptyState>
                        ) : itemsAMostrar.length > 0 ? (
                            itemsAMostrar.map((item) => {
                                const sesionBridge = sesionesHoy.find(s => s.prestacionId === item.id);
                                return (
                                    <ItemAtencion
                                        key={item.id}
                                        item={item}
                                        sesionBridge={sesionBridge}
                                        pacienteId={paciente.id}
                                        empresaId={paciente.empresaId}
                                        onRemove={handleRemoveFromSession}
                                        onComplete={handleCompleteTreatment}
                                        onRevert={handleRevertTreatment}
                                        onAskComplete={handleAskCompleteTreatment}
                                        onNoteChange={handleNoteChange}
                                        onUpdate={handleLocalUpdate}
                                        currentNote={sessionNotes[item.id]}
                                    />
                                );
                            })
                        ) : (
                            <EmptyState>
                                <h2>No hay tratamientos en esta sesión</h2>
                                <p>Para comenzar el registro clínico de hoy, vincule los tratamientos planificados o cree uno nuevo.</p>
                                <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>

                                </div>
                            </EmptyState>
                        )}
                    </SectionAtencion>

                    {atencionActiva && diagnosticos.items.length > 0 && (
                        <div style={{ marginTop: '40px' }}>
                            <WorkspaceTitle style={{ fontSize: '1.2rem', marginBottom: '15px' }}>
                                Hallazgos Clínicos Pendientes
                            </WorkspaceTitle>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                                {diagnosticos.items.map(diag => (
                                    <TarjetaAtencion key={diag.id} style={{ borderLeft: '4px solid #67D2DC' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ fontSize: '0.8rem', color: '#67D2DC', fontWeight: 'bold' }}>HALLAZGO</div>
                                            <NombreTratamiento>{diag.tratamiento}</NombreTratamiento>
                                            <DientesEtiqueta>Diente: {diag.dientes?.join(', ') || 'N/A'}</DientesEtiqueta>
                                        </div>
                                        <ButtonIniciar
                                            onClick={() => handlePlanificarDiagnostico(diag)}
                                            style={{ height: 'fit-content', padding: '8px 15px', fontSize: '0.85rem' }}
                                        >
                                            Convertir a Plan
                                        </ButtonIniciar>
                                    </TarjetaAtencion>
                                ))}
                            </div>
                        </div>
                    )}
                </ContainerBody>
                <PrestacionSeleccionModal
                    isOpen={modalSeleccionIsOpen}
                    handleCloseModal={handleCloseModals}
                />
                <NuevaPrestacionModal
                    isOpen={modalNuevoTratamientoIsOpen}
                    handleCloseModal={handleCloseModals}
                    handleAddToPlan={handleAddToPlan}
                />
                <TerminarPrestacionModal
                    isOpen={modalTerminarIsOpen}
                    handleCloseModal={handleCloseCompletionModals}
                />
                <TerminarPrestacionOdontoModal
                    isOpen={modalTerminarOdontoIsOpen}
                    handleCloseModal={handleCloseCompletionModals}
                />

                <ConfirmacionSiNoModal
                    isOpen={modalDidacticoCompletarIsOpen}
                    mensaje="Desea Marcar como Sesión Final. Al completar, se cierra el tratamiento y se actualiza de forma permanente el odontograma del paciente."
                    handleCloseModal={() => setModalDidacticoCompletarIsOpen(false)}
                    onClickYes={handleConfirmAskComplete}
                />

                <ConfirmacionSiNoModal
                    isOpen={modalConfirmacionCierreIsOpen}
                    mensaje="¿Está seguro de que desea finalizar la atención clínica?"
                    handleCloseModal={() => setModalConfirmacionCierreIsOpen(false)}
                    onClickYes={onConfirmCerrarAtencion}
                />
            </MainContainer>
        </React.Fragment>
    );
};

export default Atencion;
